export const ANIMATE = 'ANIMATE';
export const MOVE = 'MOVE';
export const MOVE_START = 'MOVE_START';
export const MOVE_STOP = 'MOVE_STOP';
export const RESIZE = 'RESIZE';
export const TAB_INDEX = 'TAB_INDEX';
export const TAB_WIDTH = 'TAB_WIDTH';
export const TRANSITION_END = 'TRANSITION_END';
